// Timezone-safe helpers for "YYYY-MM-DD" bucket keys.
//
// We deliberately avoid `Date.toISOString()` (UTC) and `new Date("YYYY-MM-DD")`
// (UTC-midnight) because both interact badly with any browser east of UTC —
// they can push a date forward or backward by a day when converting to/from
// local Date components. Instead we always work with local getters.
export function isoLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Parse a "YYYY-MM-DD" string as **local midnight**, so subsequent
// `getFullYear/getMonth/getDate` and `isoLocal(...)` calls round-trip.
export function parseIsoLocal(s) {
  if (!s || typeof s !== "string") return null;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}
